import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/main.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { getSingUp } from "../redux/action";
import { Dna } from "react-loader-spinner";

function SingUp() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.SingUp);
  //////////////////////////////////////////////////////////////////////////////////////// states
  const [UserName, setUserName] = useState({
    value: "",
    error: "Username is invalid",
    isTouched: false,
  });
  const [Email, setEmail] = useState({
    value: "",
    error: "Email is invalid",
    isTouched: false,
  });
  const [Password, setPassword] = useState({
    value: "",
    error: "Password is invalid",
    isTouched: false,
  });
  const [ConfirmPassword, setConfirmPassword] = useState({
    value: "",
    error: "Confirm Password is invalid",
    isTouched: false,
  });
  const [Mobile, setMobile] = useState({
    value: "",
    error: "Mobile is invalid",
    isTouched: false,
  });
  ///////////////////////////////////////////////////////////////////////////////////////varidations
  const verifiUserName = /^[a-z0-9_-]{5,30}$/.test(UserName.value);
  const verifiEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(Email.value);
  const verifiPassword =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/.test(
      Password.value
    );
  const verifiConfirmPassword = ConfirmPassword.value == Password.value;
  const verifiMobile = /^(09)[\w-]{9}$/.test(Mobile.value);
  //////////////////////////////////////////////////////////////////////////////////////////
  const req = async () => {
    if (
      verifiUserName &&
      verifiEmail &&
      verifiPassword &&
      verifiConfirmPassword &&
      verifiMobile
    ) {
      dispatch(
        getSingUp(UserName.value, Email.value, Password.value, Mobile.value)
      );
      setTimeout(() => {
        if (data) {
          toast.success(data.message, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate("/Login");
        } else if (error) {
          toast.warn(error, {
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }, 1000);
    }
  };
  //////////////////////////////////////////////////////////////
  function eye() {
    const password = document.querySelector("#password");
    const confirmPassword = document.querySelector("#confirmPassword");
    if (password.type === "password") {
      password.type = "text";
      confirmPassword.type = "text";
    } else if (password.type === "text") {
      password.type = "password";
      confirmPassword.type = "password";
    }
  }
  ////////////////////////////////////////////////////////////////
  return (
    <div className="mt-32 flex justify-center">
      <ToastContainer />
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        <div className=" flex justify-center shadow-lg sm:w-7/12 md:w-6/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12">
          <div className="card w-full bg-primary text-primary-content">
            <div className="card-body text-black dark:text-slate-100">
              {/* /////////////UserName//////////////// */}
              <div
                className="tooltip"
                data-tip="Username must be at least 5 characters long"
              >
                <input
                  type="text"
                  placeholder="UserName"
                  id="userName"
                  className="input input-bordered input-primary w-full text-center mb-5"
                  autoFocus
                  onChange={(e) =>
                    setUserName((last) => {
                      const help = { ...last };
                      help.value = e.target.value;
                      return { ...help };
                    })
                  }
                  onBlur={() => {
                    setUserName((last) => {
                      const help = { ...last };
                      help.isTouched = true;
                      return { ...help };
                    });
                  }}
                />
              </div>
              {!verifiUserName && UserName.isTouched && (
                <span className="absolute top-20">{UserName.error}</span>
              )}
              {/* /////////////Email//////////////// */}
              <div className="tooltip" data-tip="Email must have @ and . be">
                <input
                  type="email"
                  placeholder="Email"
                  id="email"
                  jhddndddd
                  className="input input-bordered input-primary w-full text-center mb-5"
                  onChange={(e) =>
                    setEmail((last) => {
                      const help = { ...last };
                      help.value = e.target.value;
                      return { ...help };
                    })
                  }
                  onBlur={() => {
                    setEmail((last) => {
                      const help = { ...last };
                      help.isTouched = true;
                      return { ...help };
                    });
                  }}
                />
              </div>
              {!verifiEmail && Email.isTouched && (
                <span className="absolute top-[156px]">{Email.error}</span>
              )}
              {/* /////////////Password//////////////// */}
              <div
                className="tooltip"
                data-tip="The password must be at least 8 characters long, including: a special character {!,@,#,$,%,^,&,*}, uppercase and lowercase letters, and numbers."
              >
                <input
                  type="password"
                  placeholder="Password"
                  id="password"
                  className="input input-bordered input-primary w-full text-center mb-5"
                  onChange={(e) =>
                    setPassword((last) => {
                      const help = { ...last };
                      help.value = e.target.value;
                      return { ...help };
                    })
                  }
                  onBlur={() => {
                    setPassword((last) => {
                      const help = { ...last };
                      help.isTouched = true;
                      return { ...help };
                    });
                  }}
                />
              </div>
              {!verifiPassword && Password.isTouched && (
                <span className="absolute top-[231px]">{Password.error}</span>
              )}
              {/* ////////////////////eye////////////////////// */}
              <div
                className="absolute top-[230px] right-0 w-8 mr-2 bg-slate-500 rounded-full cursor-pointer hover:scale-105 border-2 border-black"
                onClick={() => eye()}
              >
                <img src="https://img.icons8.com/external-creatype-two-colour-colourcreatype/64/null/external-eyes-basic-creatype-two-colour-colourcreatype-4.png" />
              </div>
              {/* /////////////confirm Password//////////////// */}
              <div
                className="tooltip"
                data-tip="The password confirmation must be the same as the password"
              >
                <input
                  type="password"
                  placeholder="Confirm Password"
                  id="confirmPassword"
                  className={`input input-bordered input-primary w-full text-center mb-5 ${
                    ConfirmPassword.value == Password.value && "k"
                  }`}
                  onChange={(e) =>
                    setConfirmPassword((last) => {
                      const help = { ...last };
                      help.value = e.target.value;
                      return { ...help };
                    })
                  }
                  onBlur={() => {
                    setConfirmPassword((last) => {
                      const help = { ...last };
                      help.isTouched = true;
                      return { ...help };
                    });
                  }}
                />
              </div>
              {ConfirmPassword.value !== Password.value && (
                <span className="absolute top-[308px]">
                  {ConfirmPassword.error}
                </span>
              )}
              {/* /////////////Mobile//////////////// */}
              <div
                className="tooltip"
                data-tip="Mobile number must have 11 numbers and start with 09"
              >
                <input
                  type="mobile"
                  placeholder="Mobile"
                  id="mobile"
                  className="input input-bordered input-primary w-full text-center"
                  onChange={(e) =>
                    setMobile((last) => {
                      const help = { ...last };
                      help.value = e.target.value;
                      return { ...help };
                    })
                  }
                  onBlur={() => {
                    setMobile((last) => {
                      const help = { ...last };
                      help.isTouched = true;
                      return { ...help };
                    });
                  }}
                />
              </div>
              {!verifiMobile && Mobile.isTouched && (
                <span className="absolute top-96">{Mobile.error}</span>
              )}
              {/* /////////////button//////////////// */}
              <div className="card-actions justify-center mt-5">
                <button className="btn sm:w-5/12 lg:w-4/12" onClick={req}>
                  sign up
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SingUp;
